// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lnQE","left":"styles_left__2-VtS"};